<template>
  <v-container fluid class="textoPoppins pa-2">
    <v-card class="shadowCard sv3-app">
      <v-row no-gutters class="sv3-row">
        <!-- Conversaciones -->
        <v-col cols="12" md="4" class="sv3-sidebar" :class="{ 'sv3-oculto': esMovil && chatActivo }">
          <div class="sv3-sidebar-header px-3 py-2">
            <div>
              <div class="text-subtitle-2 font-weight-bold">Susana v3 · Pruebas</div>
              <div class="text-caption grey--text">Simulador: los mensajes no salen por WhatsApp</div>
            </div>
            <v-spacer></v-spacer>
            <v-btn v-if="!verPruebas" icon small title="Nueva conversación" @click="dialogNueva = true">
              <v-icon small>mdi-plus</v-icon>
            </v-btn>
            <v-btn icon small title="Actualizar" :loading="cargandoLista" @click="cargarConversaciones()">
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </div>

          <div class="px-3 pb-1">
            <v-switch
              v-model="verPruebas"
              dense
              inset
              hide-details
              class="mt-0"
              label="Ver escenarios del runner (preguntón, spam, Daniela…)"
              @change="cambiarVista"
            ></v-switch>
          </div>

          <v-alert v-if="errorModulo" dense outlined type="warning" class="ma-2 text-caption">
            {{ errorModulo }}
          </v-alert>

          <div class="px-2 pb-2">
            <v-text-field
              v-model="buscar"
              filled
              dense
              hide-details
              clearable
              prepend-inner-icon="mdi-magnify"
              :placeholder="verPruebas ? 'Buscar escenario (ej. preguntón)' : 'Buscar teléfono'"
            ></v-text-field>
          </div>

          <div class="sv3-lista">
            <v-list dense class="py-0">
              <v-list-item
                v-for="c in conversacionesFiltradas"
                :key="c.id"
                :class="{ 'sv3-activa': chatActivo && chatActivo.id === c.id }"
                @click="abrirConversacion(c)"
              >
                <v-list-item-content>
                  <v-list-item-title class="text-body-2 font-weight-medium">
                    {{ tituloConversacion(c) }}
                    <v-chip v-if="c.canal === 'simulador'" x-small label class="ml-1">sim</v-chip>
                    <v-chip v-if="c.modo !== 'activa'" x-small label color="orange lighten-4" class="ml-1">{{ c.modo }}</v-chip>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption text-truncate">
                    <template v-if="verPruebas">{{ c.peer }} · </template>{{ c.ultimo_mensaje || 'Sin mensajes' }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <span class="text-caption grey--text">{{ formatearFecha(c.actualizada) }}</span>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-if="!conversacionesFiltradas.length && !cargandoLista" class="text-center pa-6 grey--text text-caption">
              <template v-if="verPruebas">Sin corridas del runner todavía.</template>
              <template v-else>Sin conversaciones. Crea una con <v-icon x-small>mdi-plus</v-icon> y escríbele a Susana.</template>
            </div>
          </div>
        </v-col>

        <!-- Chat -->
        <v-col cols="12" md="8" class="sv3-chat" :class="{ 'sv3-oculto': esMovil && !chatActivo }">
          <template v-if="chatActivo">
            <div class="sv3-chat-header px-3 py-2">
              <v-btn v-if="esMovil" icon small class="mr-1" @click="chatActivo = null">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <div class="text-subtitle-2 font-weight-bold">{{ tituloConversacion(chatActivo) }}</div>
                <div class="text-caption grey--text">
                  <template v-if="esPeerPrueba(chatActivo.peer)">{{ chatActivo.peer }} · </template>
                  etapa: {{ conversacion ? conversacion.etapa_funnel : '—' }}
                  · modo: {{ conversacion ? conversacion.modo : '—' }}
                  · debug: {{ conversacion && conversacion.debug ? 'on' : 'off' }}
                </div>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                icon
                small
                title="Descargar JSON (conversación, estado del lead y eventos)"
                :loading="descargando"
                :disabled="!chatActivo.id"
                @click="descargarJson"
              >
                <v-icon small>mdi-download</v-icon>
              </v-btn>
              <v-btn icon small title="Ver estado y eventos" @click="panelDetalle = !panelDetalle">
                <v-icon small>{{ panelDetalle ? 'mdi-information' : 'mdi-information-outline' }}</v-icon>
              </v-btn>
              <v-btn icon small title="Actualizar" :loading="cargandoChat" @click="cargarDetalle()">
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
              <v-btn icon small color="error" title="Reiniciar conversación" :loading="reiniciando" @click="dialogReset = true">
                <v-icon small>mdi-delete-sweep</v-icon>
              </v-btn>
            </div>

            <div class="sv3-cuerpo">
              <div ref="mensajes" class="sv3-mensajes">
                <div
                  v-for="m in mensajes"
                  :key="m.id"
                  class="sv3-fila"
                  :class="ladoMensaje(m)"
                >
                  <div class="sv3-burbuja">
                    <div v-if="m.tipo !== 'texto'" class="text-caption font-weight-bold indigo--text mb-1">
                      [{{ m.tipo }}]
                    </div>
                    <div class="sv3-texto">{{ m.contenido || '(sin texto)' }}</div>
                    <a v-if="esUrl(m.media_url)" :href="m.media_url" target="_blank" rel="noopener" class="text-caption">Abrir archivo</a>
                    <div v-else-if="m.media_url" class="text-caption grey--text">{{ m.media_url }}</div>
                    <div v-if="m.transcripcion" class="text-caption grey--text mt-1">[audio transcrito] {{ m.transcripcion }}</div>
                    <div class="sv3-meta">{{ formatearFecha(m.creado) }}</div>
                  </div>
                </div>
                <div v-if="!mensajes.length" class="text-center grey--text text-caption pa-6">
                  Escríbele algo a Susana para empezar (por ejemplo: "Hola, ¿cuánto cuesta el curso?").
                </div>
                <div v-if="enviando" class="sv3-fila sv3-out">
                  <div class="sv3-burbuja grey--text text-caption">Susana está escribiendo…</div>
                </div>
              </div>

              <div v-if="panelDetalle" class="sv3-detalle pa-2">
                <v-btn small rounded outlined block class="mb-2" :loading="descargando" @click="descargarJson">
                  <v-icon small left>mdi-download</v-icon> Descargar JSON completo
                </v-btn>
                <div class="text-caption font-weight-bold mb-1">Estado del lead</div>
                <pre class="sv3-pre">{{ estadoTexto }}</pre>
                <div class="text-caption font-weight-bold mt-3 mb-1">Eventos ({{ eventos.length }})</div>
                <v-data-table
                  :headers="headersEventos"
                  :items="eventosRecientes"
                  item-key="id"
                  dense
                  hide-default-footer
                  disable-pagination
                  class="elevation-0 sv3-tabla"
                >
                  <template v-slot:item.tipo="{ item }">
                    {{ item.tipo }}<span v-if="item.nombre"> · {{ item.nombre }}</span>
                  </template>
                  <template v-slot:item.latencia_ms="{ item }">
                    {{ item.latencia_ms != null ? item.latencia_ms + ' ms' : '' }}
                  </template>
                </v-data-table>
              </div>
            </div>

            <div v-if="soloLectura" class="px-3 py-2 text-caption grey--text">
              Conversación del runner de escenarios: solo lectura.
            </div>
            <div v-if="!soloLectura" class="px-2 pt-1">
              <v-chip
                v-for="(f, i) in frasesRapidas"
                :key="i"
                x-small
                outlined
                class="mr-1 mb-1"
                :disabled="enviando"
                @click="enviar(f.texto)"
              >{{ f.titulo }}</v-chip>
            </div>
            <div v-if="!soloLectura" class="sv3-compose px-2 pb-2">
              <v-textarea
                v-model="texto"
                filled
                dense
                hide-details
                auto-grow
                rows="1"
                placeholder="Escribe como si fueras el lead… (Enter envía, Shift+Enter salto de línea)"
                @keydown.enter.exact.prevent="enviar()"
              ></v-textarea>
              <v-btn color="primary" icon :loading="enviando" :disabled="!texto.trim()" @click="enviar()">
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </div>
          </template>

          <div v-else class="sv3-vacio d-flex align-center justify-center">
            <div class="text-center grey--text">
              <v-icon large color="grey lighten-1">mdi-robot-happy-outline</v-icon>
              <div class="mt-2">Selecciona o crea una conversación de prueba</div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="dialogNueva" max-width="420">
      <v-card>
        <v-card-title class="subtitle-1">Nueva conversación de prueba</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="nuevoTelefono"
            filled
            dense
            label="Teléfono del lead (simulado)"
            hint="Cualquier número; no se le envía nada. Ej. 5218100000001"
            persistent-hint
            @keydown.enter.prevent="crearConversacion"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="dialogNueva = false">Cancelar</v-btn>
          <v-btn color="primary" small rounded :disabled="!telefonoValido" @click="crearConversacion">Crear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogReset" max-width="420">
      <v-card>
        <v-card-title class="subtitle-1">Reiniciar conversación</v-card-title>
        <v-card-text>Se borran los mensajes, eventos y el estado de esta conversación de prueba.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="dialogReset = false">Cancelar</v-btn>
          <v-btn color="error" small rounded :loading="reiniciando" @click="reiniciar">Reiniciar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const BASE = 'susana-v3'

export default {
  name: 'SusanaV3Simulador',

  data: () => ({
    conversaciones: [],
    chatActivo: null,
    conversacion: null,
    mensajes: [],
    eventos: [],
    handoffs: [],
    descargando: false,
    verPruebas: false,
    buscar: '',
    texto: '',
    nuevoTelefono: '',
    cargandoLista: false,
    cargandoChat: false,
    enviando: false,
    reiniciando: false,
    dialogNueva: false,
    dialogReset: false,
    panelDetalle: false,
    errorModulo: '',
    headersEventos: [
      { text: 'Tipo', value: 'tipo', sortable: false },
      { text: 'Latencia', value: 'latencia_ms', sortable: false },
      { text: 'Tokens in/out', value: 'tokens', sortable: false },
    ],
    frasesRapidas: [
      { titulo: 'Hola', texto: 'Hola, quiero información del curso de inglés' },
      { titulo: 'Precio', texto: '¿Cuánto cuesta?' },
      { titulo: 'Varios datos', texto: 'Soy Daniela, es para mí, tengo 27 y lo quiero presencial en Monterrey' },
      { titulo: '¿Eres robot?', texto: '¿Eres un robot?' },
      { titulo: 'Lo voy a pensar', texto: 'Lo voy a pensar' },
      { titulo: 'Humano', texto: 'Quiero hablar con una persona' },
      { titulo: '#debug on', texto: '#debug on' },
      { titulo: '#estado', texto: '#estado' },
    ],
  }),

  computed: {
    esMovil() {
      return this.$vuetify.breakpoint.smAndDown
    },
    soloLectura() {
      return this.verPruebas || String((this.chatActivo && this.chatActivo.peer) || '').indexOf('test:') === 0
    },
    conversacionesFiltradas() {
      const q = this.normalizarBusqueda(this.buscar)
      const lista = this.conversaciones.slice().sort((a, b) => {
        if (!this.verPruebas) return 0
        return String(this.tituloConversacion(a)).localeCompare(String(this.tituloConversacion(b)), 'es')
      })
      if (!q) return lista
      return lista.filter((c) => {
        const peer = this.normalizarBusqueda(c.peer)
        const titulo = this.normalizarBusqueda(this.tituloConversacion(c))
        return peer.indexOf(q) !== -1 || titulo.indexOf(q) !== -1
      })
    },
    telefonoValido() {
      return String(this.nuevoTelefono || '').replace(/\D/g, '').length >= 10
    },
    estadoTexto() {
      const estado = this.conversacion && this.conversacion.estado ? this.conversacion.estado : {}
      return JSON.stringify(estado, null, 2)
    },
    eventosRecientes() {
      return this.eventos
        .slice(-30)
        .reverse()
        .map((e) => ({ ...e, tokens: e.tokens_in != null ? `${e.tokens_in}/${e.tokens_out || 0}` : '' }))
    },
  },

  mounted() {
    this.cargarConversaciones()
  },

  methods: {
    aviso(mensaje, tipo = 'info') {
      this.$store.commit('mostrarAlerta', { mensaje, tipo })
    },

    normalizarBusqueda(texto) {
      return String(texto || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    },

    esPeerPrueba(peer) {
      return String(peer || '').indexOf('test:') === 0
    },

    /** Peer test:16:persona_pregunton:1 → "Preguntón". */
    tituloConversacion(c) {
      const peer = (c && c.peer) || ''
      const m = String(peer).match(/^test:\d+:([^:]+):\d+$/)
      if (!m) return peer
      const nombres = {
        persona_pregunton: 'Preguntón',
        persona_presencial_a_online: 'Presencial → online',
        persona_menor_de_edad: 'Menor de edad',
        persona_grupos_pide_zona: 'Grupos (pide zona)',
        persona_spam: 'Spam publicidad',
        persona_spam_imagen: 'Spam imagen indebida',
        referencia_daniela_completa: 'Referencia Daniela',
      }
      return nombres[m[1]] || String(m[1]).replace(/_/g, ' ')
    },

    mensajeError(error, porDefecto) {
      if (error && error.response && error.response.status === 404) {
        return 'Susana v3 no está activa en el API (falta SUSANA_V3_ENABLED=1 o reiniciar api-rh).'
      }
      if (error && error.response && error.response.data) {
        const d = error.response.data
        if (d.error) return d.error
        if (d.message) return d.message
      }
      return porDefecto
    },

    async cargarConversaciones(silencioso = false) {
      if (!silencioso) this.cargandoLista = true
      try {
        const res = await this.$http.get(`${BASE}/admin/conversaciones`, { params: this.verPruebas ? { es_prueba: 1 } : {} })
        this.conversaciones = (res.data && res.data.data) || []
        this.errorModulo = ''
      } catch (error) {
        this.errorModulo = this.mensajeError(error, 'No se pudieron cargar las conversaciones')
      } finally {
        this.cargandoLista = false
      }
    },

    cambiarVista() {
      this.chatActivo = null
      this.conversacion = null
      this.mensajes = []
      this.eventos = []
      this.handoffs = []
      this.cargarConversaciones()
    },

    ladoMensaje(m) {
      const deSusana = m.direccion === 'out'
      if (this.soloLectura) return deSusana ? 'sv3-in' : 'sv3-out'
      return deSusana ? 'sv3-out' : 'sv3-in'
    },

    esUrl(valor) {
      return /^https?:\/\//i.test(String(valor || ''))
    },

    abrirConversacion(c) {
      this.chatActivo = c
      this.conversacion = null
      this.mensajes = []
      this.eventos = []
      this.handoffs = []
      this.cargarDetalle()
    },

    async cargarDetalle() {
      if (!this.chatActivo || !this.chatActivo.id) return
      this.cargandoChat = true
      try {
        const res = await this.$http.get(`${BASE}/admin/conversaciones/${this.chatActivo.id}`)
        const data = (res.data && res.data.data) || {}
        this.conversacion = data.conversacion || null
        this.mensajes = data.mensajes || []
        this.eventos = data.eventos || []
        this.handoffs = data.handoffs || []
        this.bajarScroll()
      } catch (error) {
        this.aviso(this.mensajeError(error, 'No se pudo cargar la conversación'), 'error')
      } finally {
        this.cargandoChat = false
      }
    },

    crearConversacion() {
      if (!this.telefonoValido) return
      const peer = String(this.nuevoTelefono).replace(/\D/g, '')
      const existente = this.conversaciones.find((c) => c.peer === peer)
      this.dialogNueva = false
      this.nuevoTelefono = ''
      if (existente) return this.abrirConversacion(existente)
      this.chatActivo = { id: null, peer, canal: 'simulador', modo: 'activa' }
      this.conversacion = null
      this.mensajes = []
      this.eventos = []
    },

    async enviar(textoForzado) {
      const mensaje = String(textoForzado != null ? textoForzado : this.texto).trim()
      if (!mensaje || !this.chatActivo || this.enviando) return
      this.enviando = true
      this.mensajes.push({ id: `tmp-${Date.now()}`, direccion: 'in', tipo: 'texto', contenido: mensaje, creado: new Date().toISOString() })
      if (textoForzado == null) this.texto = ''
      this.bajarScroll()
      try {
        const res = await this.$http.post(`${BASE}/simular`, { peer: this.chatActivo.peer, mensaje })
        const data = res.data || {}
        if (data.conversacionId && !this.chatActivo.id) {
          this.chatActivo = { ...this.chatActivo, id: data.conversacionId }
        }
        await this.cargarDetalle()
        this.cargarConversaciones(true)
      } catch (error) {
        this.mensajes = this.mensajes.filter((m) => String(m.id).indexOf('tmp-') !== 0)
        if (textoForzado == null) this.texto = mensaje
        this.aviso(this.mensajeError(error, 'Susana no pudo responder'), 'error')
      } finally {
        this.enviando = false
      }
    },

    async reiniciar() {
      if (!this.chatActivo || !this.chatActivo.id) {
        this.dialogReset = false
        return
      }
      this.reiniciando = true
      try {
        await this.$http.post(`${BASE}/admin/conversaciones/${this.chatActivo.id}/reset`)
        this.dialogReset = false
        await this.cargarDetalle()
        this.cargarConversaciones(true)
        this.aviso('Conversación reiniciada', 'success')
      } catch (error) {
        this.aviso(this.mensajeError(error, 'No se pudo reiniciar'), 'error')
      } finally {
        this.reiniciando = false
      }
    },

    parsearJson(valor) {
      if (typeof valor !== 'string' || !valor) return valor
      try {
        return JSON.parse(valor)
      } catch (e) {
        return valor
      }
    },

    armarExportacion() {
      const conv = Object.assign({}, this.conversacion || {})
      delete conv.estado_json
      const mensajes = this.mensajes.map((m) => Object.assign({}, m, { meta_json: this.parsearJson(m.meta_json) }))
      const eventos = this.eventos.map((e) => Object.assign({}, e, { payload_json: this.parsearJson(e.payload_json) }))

      const porTurno = {}
      const orden = []
      const agregar = (turnoId, campo, item) => {
        const clave = turnoId || 'sin_turno'
        if (!porTurno[clave]) {
          porTurno[clave] = { turno_id: turnoId || null, mensajes: [], eventos: [] }
          orden.push(clave)
        }
        porTurno[clave][campo].push(item)
      }
      mensajes.forEach((m) => agregar(m.turno_id, 'mensajes', m))
      eventos.forEach((e) => agregar(e.turno_id, 'eventos', e))

      return {
        exportado: new Date().toISOString(),
        resumen: {
          conversacion_id: conv.id,
          peer: conv.peer,
          canal: conv.canal,
          etapa_funnel: conv.etapa_funnel,
          modo: conv.modo,
          total_mensajes: mensajes.length,
          total_eventos: eventos.length,
          total_turnos: orden.filter((k) => k !== 'sin_turno').length,
          total_handoffs: this.handoffs.length,
        },
        estado_lead: conv.estado || {},
        conversacion: conv,
        turnos: orden.map((k) => porTurno[k]),
        mensajes,
        eventos,
        handoffs: this.handoffs,
      }
    },

    async descargarJson() {
      if (!this.chatActivo || !this.chatActivo.id) return
      this.descargando = true
      try {
        await this.cargarDetalle()
        if (!this.conversacion) return
        const contenido = JSON.stringify(this.armarExportacion(), null, 2)
        const blob = new Blob([contenido], { type: 'application/json;charset=utf-8' })
        const url = URL.createObjectURL(blob)
        const fecha = new Date().toISOString().slice(0, 16).replace(/[-:T]/g, '')
        const a = document.createElement('a')
        a.href = url
        a.download = `susana-v3_${this.conversacion.peer}_conv${this.conversacion.id}_${fecha}.json`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } finally {
        this.descargando = false
      }
    },

    bajarScroll() {
      this.$nextTick(() => {
        const el = this.$refs.mensajes
        if (el) el.scrollTop = el.scrollHeight
      })
    },

    formatearFecha(valor) {
      if (!valor) return ''
      const d = new Date(String(valor).replace(' ', 'T'))
      if (Number.isNaN(d.getTime())) return String(valor)
      return d.toLocaleString('es-MX', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit' })
    },
  },
}
</script>

<style scoped>
.sv3-app {
  height: calc(100vh - 120px);
  min-height: 480px;
  overflow: hidden;
}
.sv3-row {
  height: 100%;
}
.sv3-sidebar {
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e0e4ea;
  height: 100%;
}
.sv3-sidebar-header,
.sv3-chat-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e0e4ea;
  background: #f5f7fa;
}
.sv3-lista {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}
.sv3-activa {
  background: #eef3fb;
}
.sv3-chat {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.sv3-cuerpo {
  flex: 1;
  display: flex;
  min-height: 0;
}
.sv3-mensajes {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #efeae2;
}
.sv3-detalle {
  width: 340px;
  max-width: 45%;
  overflow-y: auto;
  border-left: 1px solid #e0e4ea;
  background: #fafbfc;
}
.sv3-fila {
  display: flex;
  margin-bottom: 8px;
}
.sv3-in {
  justify-content: flex-end;
}
.sv3-out {
  justify-content: flex-start;
}
.sv3-burbuja {
  max-width: 75%;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.08);
}
.sv3-in .sv3-burbuja {
  background: #d9fdd3;
}
.sv3-texto {
  white-space: pre-line;
  word-break: break-word;
}
.sv3-meta {
  font-size: 10px;
  color: #667781;
  text-align: right;
  margin-top: 4px;
}
.sv3-pre {
  font-size: 11px;
  background: #fff;
  border: 1px solid #e0e4ea;
  border-radius: 6px;
  padding: 8px;
  max-height: 220px;
  overflow: auto;
  margin: 0;
}
.sv3-tabla {
  font-size: 11px;
}
.sv3-compose {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}
.sv3-vacio {
  height: 100%;
  min-height: 320px;
}
@media (max-width: 960px) {
  .sv3-oculto {
    display: none !important;
  }
  .sv3-detalle {
    display: none;
  }
}
</style>
